export default [
  {
    title: 'breadcrumb.liveBetting',
    route: 'live-betting',
    icon: '',
    resource: 'live-betting',
    action: 'read',
  }
];